import LinearProgress from '@mui/material/LinearProgress';

import { useWorkspaceSyncStatus } from 'contexts/WorkspaceSyncStatusContext';

export default function SyncProgressBar() {
  const { isSyncing, status } = useWorkspaceSyncStatus();

  if (!isSyncing && status !== 'error') {
    return null;
  }

  return (
    <LinearProgress
      aria-label={status === 'error' ? 'Integration sync failed' : 'Integration sync in progress'}
      color={status === 'error' ? 'error' : 'primary'}
      variant="indeterminate"
      sx={{
        position: 'absolute',
        insetInline: 0,
        top: 0,
        height: 3,
        bgcolor: 'transparent',
        '& .MuiLinearProgress-bar': {
          borderRadius: 999
        }
      }}
    />
  );
}
